export default "__VITE_ASSET__B0jz_bkD__"